import { gql } from "@apollo/client";

export const CLIP_REQUEST_PORTRAIT = gql`
  mutation ClipRequestPortrait($input: ClipRequestPortraitInput!) {
    clipRequestPortrait(input: $input) {
      success
    }
  }
`;
